<script lang="ts">
    import { onDestroy } from 'svelte'
    import { fade } from 'svelte/transition'

    import Icon from '@iconify/svelte'

    import { gettext as _ } from 'hydria/services/gettext'

    // import { makeSphinxTag } from 'hydria/utils/sphinx'

    import { loadFrequentTags, type FTag } from 'admin/helpers/tags'

    interface Props {
        filter?: (text: string) => void
        close: () => void
    }

    let { filter, close }: Props = $props()

    $effect(() => {
        if (!document.documentElement.classList.contains('modal-open')) {
            document.documentElement.classList.add('modal-open')
        } else if (document.documentElement.classList.contains('modal-open')) {
            document.documentElement.classList.remove('modal-open')
        }
    })

    onDestroy(() => {
        if (document.documentElement.classList.contains('modal-open')) document.documentElement.classList.remove('modal-open')
    })

    function applyTag(tag: string) {
        let text = `tag:${tag}`
        if (filter) filter(text)
    }

    let globalFrequentTags: FTag[] | undefined = $state(undefined)

    loadFrequentTags('user').then((r) => {
        globalFrequentTags = r
    })
</script>

<style>
    .modal-dialog {
        --bs-modal-width: 85vw;
    }
    ul.dom-search-sample {
        columns: 28em auto;
    }
    li {
        margin: 0.1rem 0;
    }
</style>

<div class="modal" role="dialog" transition:fade={{ duration: 250 }}>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header text-bg-primary">
                <div>Filtres spéciaux</div>
            </div>
            <div class="modal-body">
                <p>« Tags » :</p>
                <ul class="dom-search-sample">
                    {#if globalFrequentTags}
                        {#if globalFrequentTags.length}
                            {#each globalFrequentTags as tag}
                                <li>
                                    <code>tag:{tag.id}</code>
                                    <div class="btn-group btn-group-sm">
                                        <button class="btn btn-outline-secondary" onclick={() => applyTag(tag.id)}><Icon inline icon="mdi:check" /></button>
                                    </div>
                                </li>
                            {/each}
                        {:else}
                            <li class="text-italic">(aucun tag)</li>
                        {/if}
                    {:else}
                        <li>
                            <div class="spinner-border me-3" role="status" aria-hidden="true"></div>
                        </li>
                    {/if}
                </ul>
            </div>
            <div class="modal-footer text-bg-light">
                <button class="btn btn-outline-secondary" onclick={() => close()}>{$_('Close')}</button>
            </div>
        </div>
    </div>
    <div
        class="modal-backdrop"
        aria-hidden="true"
        onclick={() => {
            close()
        }}
    ></div>
</div>
